import { render, staticRenderFns } from "./SectionAgencyLegalInformationKpp.vue?vue&type=template&id=cce2edea&"
import script from "./SectionAgencyLegalInformationKpp.vue?vue&type=script&lang=js&"
export * from "./SectionAgencyLegalInformationKpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports